import styled from 'styled-components'

export const FlexSpaceBetweenAtom = styled.div<{ $gap?: number }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ $gap }) => $gap ?? 0}px;
  width: 100%;
`
